import { configure, makeAutoObservable } from "mobx";
import secureLocalStorage from "react-secure-storage";
class SessionStore {
    ls = {
        wouser: null,
        changepasswordData: null
    };
    ss = {
        headerObj: null
    };

    suggest = {};

    _loadingCnt = 0;

    set loadingCnt(value) {
        this._loadingCnt += value;
    }

    get loadingCnt() {
        return this._loadingCnt;
    }

    constructor() {
        makeAutoObservable(this);
        configure({
            enforceActions: 'never',
        })
    }

    setAuth(value) {
        this.ls.wouser = value;
        secureLocalStorage.setItem('ls.wouser', JSON.stringify(value));
    }
    getAuth() {
        const wouser = JSON.parse(secureLocalStorage.getItem('ls.wouser'));
        if (wouser && !this.ls.wouser) {
            this.ls.wouser = wouser;
            return wouser;
        };
        return this.ls.wouser;
    }

    resetAuth() {
        this.ls.wouser = null;
        secureLocalStorage.removeItem('ls.wouser');
        this.resetSuggest();
    }
    setPasswordData(value) {
        this.ls.changepasswordData = value;
    }
    setHeader(value) {
        this.ss.headerObj = value;
    }

    setSuggestItems(item, value) {
        this.suggest[item] = value;
        secureLocalStorage.setItem(`suggest${item}`, JSON.stringify(value));
    }

    getSuggestItems(item) {
        const suggest = JSON.parse(secureLocalStorage.getItem(`suggest${item}`));
        if (suggest && !this.suggest[item]) {
            this.suggest[item] = suggest;
        };
        return this.suggest[item];
    }

    resetSuggest() {
        if (Object.keys(this.suggest).length) {
            const keys = Object.keys(this.suggest);
            this.suggest = {};
            keys.map(key => {
                secureLocalStorage.removeItem(`suggest${key}`);
            })
        }
    }
}


const sessionStore = new SessionStore();

export default sessionStore;
